import { t as o } from 'i18next';
import { commonFields } from './common-fields';

function t(s) {
  return s;
}

const fields = [
  { name: 'id', displayName: 'Id' },
  { name: 'name', displayName: 'Επωνυμία' },

  ...commonFields,
];

const childs = [{ tableName: '' }];

const collectionpoints = {
  name: 'collectionpoints',
  displayName: 'Σημεία Συλλογής',
  fields: fields,
  childTables: childs,
};

export { collectionpoints };
